<template>
  <v-app
    v-if="allowedDomain"
    :style="{
      'overflow-y':
        getWebchat().interaction.state == 'started' ? 'hidden' : 'auto',
    }"
  >
    <welcome-message
      class="welcome-message-header"
      v-if="showWelcome"
    ></welcome-message>
    <accessibility-options />
    <router-view ref="view"></router-view>
  </v-app>
</template>

<script>
import { checkMobile, isIOS } from "./assets/utils";
import Chat from "./components/chat";
import EventsLog from "./assets/EventsLog";
import Constants from "./assets/Constants";
import WelcomeMessage from "./components/welcome-message.vue";
import AccessibilityOptions from "./components/accessibility-options.vue";

export default {
  name: "app",
  components: {
    Chat,
    WelcomeMessage,
    AccessibilityOptions,
  },

  data() {
    return {
      allowedDomain: true,
      eventsLog: new EventsLog(this.$http),
      broadcastedColor: false,
    };
  },

  computed: {
    showWelcome() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      let interactionState = this.$store.state[index].interaction.state;
      return (
        interactionState != Constants.STARTED_STATE &&
        interactionState != Constants.FINISHED_STATE
      );
    },
  },

  created() {
    this.init();
  },

  methods: {
    /**
     * @name INIT
     * @desc App initial loader
     */
    init() {
      // If conf is already loaded
      if (this.$route.query.ip) {
        this.$store.commit({
          type: "addConfiguration",
          param: this.$route.query,
        });
      }

      if (this.getWebchat().client && !this.getWebchat().client.accessibility) {
        this.$store.commit("setAccessibilityFontSize", 0);
      }

      this.isOnTime();
      this.checkRouter();
      this.appReady();

      window.parent.postMessage(
        {
          action: "WEBCHAT_SIZE",
          size: this.getWebchat().client.accessibility.fontSize,
        },
        "*"
      );
    },

    /**
     * @name APPLICATION_READY
     * @desc Broadcast parent ready state && creates
     *       event handler for parent events
     */
    appReady() {
      this.$store.commit("isMobile", checkMobile());
      this.$store.commit("isIOS", isIOS());
    },

    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },

    hasParameters() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      return (
        this.$store.state[index].configuration.name &&
        this.$store.state[index].configuration.mail
      );
    },

    startChatWithParameters() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      this.$store.commit("setClientInfo", {
        name: this.$store.state[index].configuration.name,
        mail: this.$store.state[index].configuration.mail,
        number: this.$store.state[index].configuration.number || "",
        initialMessage: this.$store.state[index].configuration.initialMessage,
        data: this.$store.state[index].configuration.data,
      });

      this.$store.commit("newGuid");
      this.$router.push({
        path: "chat",
        query: {
          campaign: campaignName,
        },
      });
    },

    /**
     * @name CHECK_ROUTER
     * @desc Checks interaction state and re-routes to corresponding page
     */
    checkRouter() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      let state = this.$store.state[index].interaction.state;
      if (state === Constants.NOT_STARTED_STATE) {
        if (this.hasParameters()) {
          this.startChatWithParameters();
        } else {
          this.$router.push({
            path: "form",
            query: {
              campaign: campaignName,
            },
          });
        }
      } else if (
        state === Constants.WAITING_STATE ||
        state === Constants.STARTED_STATE
      ) {
        this.$router.push({
          path: "chat",
          query: {
            campaign: campaignName,
          },
        });
      } else if (state === Constants.FINISHED_STATE) {
        this.$router.push({
          path: "form",
          query: {
            campaign: campaignName,
          },
        });
      }
    },

    /**
     * @name IS_ON_TIME
     * @desc Checks interaction state in server
     */
    async isOnTime() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      try {
        let response = await this.$http.get(
          "https://" +
            this.$store.state[index].configuration.ip +
            "/IntegraChannels/resources/webchat/isOnTimeV2",
          {
            params: {
              campaign: this.$store.state[index].configuration.campaign,
            },
          }
        );
        this.onResponseTime(response.data);
      } catch (error) {
        // In case of error fetching information from the server
        // set { onTime:false } since there's no info on the campaign
        this.$store.commit("setOnTime", { param: { onTime: false } });
        console.log("ERROR FETCHING INFO:" + error);
      }
    },

    deB64(texto) {
      try {
        return decodeURIComponent(escape(window.atob(texto)));
      } catch (err) {
        console.error(err);
        return atob(texto);
      }
    },
    /**
     * @name ON_RESPONSE
     * @desc On successful response, it parses the data from server
     */
    onResponseTime: function (res) {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      if (!res) return;
      let response = JSON.parse(this.deB64(res));
      response.outoftime = JSON.parse(response.outoftime);
      response.welcome = JSON.parse(response.welcome);
      response.feedback = JSON.parse(response.feedback);
      response.holdtimemessage = JSON.parse(response.holdtimemessage);
      let turnConf = {
        TurnServer: response.TurnServer,
        TurnUser: response.TurnUser,
        TurnPassword: response.TurnPassword
      }
      let telephonyServer = response.telephonyServer;

      let allowedDomain =
        window.location.href.indexOf(response.allowedDomains || "") > -1;

      if (
        !response.allowedDomains ||
        (response.allowedDomains && allowedDomain)
      ) {
        if (response.custom_field) {
          response.custom_field = JSON.parse(response.custom_field);
        } else {
          // Default value in case it's an old setting
          response.custom_field = {
            required: false,
            visible: true,
            text: {
              en: "Phone Number",
              es: "Telefono",
              pt: "Telefone",
            },
          };
        }

        let defaultobj = {
          es: "No disponible",
          en: "Not available",
          pt: "Não disponível",
        };

        if (response.notavailablemessage) {
          response.notavailablemessage = JSON.parse(
            response.notavailablemessage
          );
          if (
            !response.notavailablemessage.es &&
            !response.notavailablemessage.en &&
            !response.notavailablemessage.pt
          ) {
            response.notavailablemessage = defaultobj;
          }
        } else {
          response.notavailablemessage = defaultobj;
        }

        this.$store.commit({ type: "setOnTime", param: response });

        this.$store.commit("setFeedback", response.feedback);

        this.$store.commit("setIpAddress", response.ipAddress);

        this.$store.commit("setCampaignLogo", response.logo);

        this.$store.commit(
          "setCampaignLogoName",
          this.$store.state[index].configuration.campaign
        );

        this.$store.commit("setTurnConf", turnConf);

        this.$store.commit("setTelephonyServer", telephonyServer);

        if (!this.broadcastedColor) {
          setTimeout(() => {
            window.parent.postMessage(
              { action: "SET_COLOR", color: response.color },
              "*"
            );
          }, 500);
          this.broadcastedColor = true;
        }

        // if not available, keep on fetching utill it is
        if (!response.available) {
          setTimeout(this.isOnTime, 10000);
        }
      } else {
        this.allowedDomain = false;
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Color+Emoji&display=swap");

/* Pages Transitions */
.slide-fade-enter-active {
  transition: all 0.3s ease;
  opacity: 1;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(30px);
  opacity: 0;
}

#app {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: auto;
  overflow-x: hidden;
  border-radius: 6px;
  background-color: rgb(255, 255, 255);
}

html {
  width: 100%;
  height: 100%;
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
}

html::-webkit-scrollbar {
  width: 0 !important;
}

body {
  width: 100%;
  height: 100%;
  margin: 0px !important;
}

.v-application {
  font-family: "Open Sans", sans-serif !important;
}

/* Animate css */
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}
@-moz-document url-prefix() {
  .fadeInUp {
    -moz-animation-name: unset;
    animation-name: unset;
  }
}

/* End Animated css */
.vue-app-mobile-sizes {
  height: 98% !important;
  margin-top: 0;
}

.chat-height {
  height: 100%;
}

.card-holder-sizes {
  height: 55% !important;
  margin-top: 10em !important;
}

a {
  color: inherit !important;
}
</style>
